import React, { PropTypes, Component } from 'react'
import styles from './SelectWrap.scss'
import i18n from '../../../lib/i18n'
import Select, { components as reactSelectComponents } from 'react-select'

const i18selectWrap = i18n('selectWrapper')
const i18claimsZoom = i18n('claimsZoom')

let selectInFocusWithin = false

const customCreatableSelectStyles = {
    control: (base, { isDisabled, isFocused }) => {
        selectInFocusWithin = isFocused
        return {
            ...base,
            fontSize: "12px",
            color: "#000",
            opacity: isDisabled ? 0.5 : 1,
            borderRadius: "2px",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: isFocused ? "#08c #0099e6 #0099e6" : "#d9d9d9 #ccc #b3b3b3",
            backgroundColor: isDisabled ? "#F6F6F6" : "#FFFFFF",
            minHeight: "25px",
            boxShadow: null,
            padding: 0,
            margin: 0,
            overflow: isFocused ? null : "hidden",
            "&:focus": {
                borderColor: "#08c #0099e6 #0099e6",
            },
        }
    },
    menu: (base) => ({
        ...base,
        borderRadius: 2,
        hyphens: "auto",
        marginTop: 0,
        textAlign: "left",
        wordWrap: "break-word",
    }),
    menuList: base => ({
        ...base,
        padding: 0,
        verticalAlign: "baseline",
        fontSize: "12px",
    }),
    singleValue: (base) => ({
        ...base,
        minHeight: "16px",
        lineHeight: "34px",
        color: "#333333",
        fontSize: "12px",
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? '#f2f9fc' : 'transparent',
        color: state.isFocused ? '#333' : '#666',
        "&:hover": {
            color: '#333',
            backgroundColor: '#f2f9fc',
        },
    }),
    valueContainer: (base) => ({
        ...base,
        margin: 0,
        padding: "0px 8px",
        height: "100%",
        fontSize: "12px",
    }),
    clearIndicator: (base) => ({
        ...base,
        padding: 0,
        "& svg": {
            height: "13px",
            width: "13px",

            "&:hover": {
                color: "#d0021b",
            },
        },
    }),
    dropdownIndicator: (base) => ({
        ...base,
        marginTop: 0,
        padding: 0,
    }),
    placeholder: (base) => ({
        ...base,
        overflow: "hidden",
        textOverflow: "ellipsis",
    }),
    multiValueRemove: (base) => ({
        ...base,
        borderRadius: "2px 0 0 2px",
        borderRight: "1px solid rgba(70,178,112, 0.24)",
        "&:hover": {
            backgroundColor: '#ddeff7',
            color: '#0077b3',
        },
        "& svg": {
            height: "10px",
            width: "10px",
        },
    }),
    indicatorSeparator: (base) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "0",
        top: 0,
    }),
    input: (base) => ({
        ...base,
        padding: 0,
        margin: "2px 0 0 0",
        height: "20px",
        top: 0,
        fontSize: '12px',
        lineHeight: '0.8em',
        caretColor: 'transparent',
        width: selectInFocusWithin ? '100%!important' : 'auto',
        div: {
            width: selectInFocusWithin ? '100%!important' : 'auto',
            input: {
                width: selectInFocusWithin ? '100%!important' : 'auto',
            },
        },
    }),
    noOptionsMessage: (base) => ({
        ...base,
        padding: 0,
        margin: 0,
        height: "20px",
        fontSize: '0.78em',
    }),
}

function noOptionsMessage({ inputValue }) { // eslint-disable-line no-unused-vars
    return i18claimsZoom('noResultsText')
}

const DropdownIndicator = (props) => {
    return reactSelectComponents.DropdownIndicator && (
        <reactSelectComponents.DropdownIndicator {...props}>
            <span className={styles.downArrowHolder}>
                <span className={styles.downArrow}></span>
            </span>
        </reactSelectComponents.DropdownIndicator>
    )
}

const NoOptionsMessage = (props) => {
    return reactSelectComponents.DropdownIndicator && (
        <reactSelectComponents.NoOptionsMessage {...props} className={styles.noOptionsMessage}>
            {i18selectWrap('noOptions')}
        </reactSelectComponents.NoOptionsMessage>
    )
}
/**
 * Base Wrapper for React Select Component
 * @param {Object} props - react-select@2.4.4 props
 */
export const ReactSelect = (props) => (
    <Select
        {...props}
        noOptionsMessage={noOptionsMessage}
        classNamePrefix="select"
        styles={{ ...customCreatableSelectStyles }}
        components={{ DropdownIndicator, NoOptionsMessage, ...props.components }}
    />
)
ReactSelect.propTypes = {
    components: PropTypes.object,
}

export const SelectWrapper = ({ value, options, onBlur, onChange, ...props }) => {
    let selectedValue = value
    if (typeof selectedValue === 'string') {
        selectedValue = options.find(option => option.value === selectedValue) // This code enables the select to work with the new react-select
    }
    return (
        <ReactSelect
            placeholder=""
            value={selectedValue}
            options={options}
            isClearable={false}
            isSearchable={false}
            onChange={(newValue) => onChange(newValue)}
            onBlur={() => onBlur ? onBlur(selectedValue) : null}
            {...props}
        />
    )
}
SelectWrapper.propTypes = {
    value: PropTypes.any,
    options: PropTypes.array,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
}

export const SearchableSelectWrapper = ({ value, options, onBlur, onChange, ...props }) => {
    let selectedValue = value
    if (typeof selectedValue === 'string') {
        // This code enables the select to work with the new react-select
        selectedValue = options.find(option => option.value === selectedValue)
    }

    return (
        <ReactSelect
            placeholder=""
            value={selectedValue}
            options={options}
            onChange={(newValue) => onChange(newValue)}
            onBlur={() => onBlur ? onBlur(selectedValue) : null}
            {...props}
            isSearchable // Searchable is true by default
        />
    )
}
SearchableSelectWrapper.propTypes = {
    value: PropTypes.any,
    options: PropTypes.array,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
}

//this piece of art is here because handleOnBlur doesn't update the state before handleMenuClose reads it
let forceMenuOpen = false
/**
 * select used for client profile edit BEWB 804 to have a dynamic options list for some fields with one option 
 * acting as a toggle button to show more or less options
 */
export class SearchableDynamicListSelectWrapper extends Component {
    static propTypes = {
        value: PropTypes.any,
        options: PropTypes.array,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        toggleShowFullList: PropTypes.func,
    }
    constructor(props) {
        super(props)
        this.state = {
            menuIsOpen: false,
            selectedValue: ''
        }
    }

    componentDidMount() {
        const { value, options, toggleShowFullList } = this.props
        if (value) {

            if (typeof value === 'string') {
                // This code enables the select to work with the new react-select
                const selectedValue = options.some(option => option.value === value)
                if (!selectedValue) {
                    toggleShowFullList('see_more_results')
                }
            }
        }
    }

    async handleChange(newVal) {
        const { onChange, toggleShowFullList } = this.props
        const value = newVal.value
        if (value === 'see_more_results' || value === 'see_less_results') {
            toggleShowFullList(value)
            forceMenuOpen = true
            await this.setState({ menuIsOpen: true })
            onChange({})
        } else {
            forceMenuOpen= false
            await this.setState({  menuIsOpen: false })
            onChange(newVal)
        }
    }

    handleMenuClose() {
        if (forceMenuOpen) {
            this.setState({ menuIsOpen: true });
        } else {
            this.setState({ menuIsOpen: false });
        }
    }

    handleMenuOpen() {
        this.setState({ menuIsOpen: true });
    }

    handleOnBlur() {
        const {value, onBlur, options} = this.props
        forceMenuOpen = false

        this.setState({forceMenuOpen: false,  menuIsOpen: false}, () => {
            let selectedValue = value

            if (typeof selectedValue === 'string') {
                // This code enables the select to work with the new react-select
                selectedValue = options.find(option => option.value === selectedValue)
            }
            if(onBlur){
                return onBlur(selectedValue)
            }
        })
    }

    render() {
        const { value, options, onBlur } = this.props
        const { menuIsOpen, /*selectedValue*/ } = this.state
        let selectedValue = value

        if (typeof selectedValue === 'string') {
            // This code enables the select to work with the new react-select
            selectedValue = options.find(option => option.value === selectedValue)
        }
        return (
            <ReactSelect
                placeholder=""
                value={selectedValue}
                options={options}
                onChange={(newValue) => this.handleChange(newValue)}
                onBlur={() =>  this.handleOnBlur()}
                // {...this.props}
                isSearchable // Searchable is true by default
                menuIsOpen={menuIsOpen}
                onMenuClose={() => this.handleMenuClose()}
                onMenuOpen={() => this.handleMenuOpen()}
            />
        )
    }
}

export default SelectWrapper



// WEBPACK FOOTER //
// ./components/shared/select/SelectWrap.jsx